import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
}

const Card: React.FC<CardProps> = ({ children, className = '' }) => (
  <div
    className={
      'bg-white border border-solid border-brand-300 rounded-md shadow-card px-4 py-4 ' + className
    }
  >
    {children}
  </div>
);

export default Card;
